"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  click: 'onClick',
  dblclick: 'onDblClick',
  mousedown: 'onMouseDown',
  mouseup: 'onMouseUp',
  mouseenter: 'onMouseEnter',
  mouseleave: 'onMouseLeave',
  mouseover: 'onMouseOver',
  mousemove: 'onMouseMove',
  mouseout: 'onMouseOut',
  dragstart: 'onDragStart',
  drag: 'onDrag',
  dragenter: 'onDragEnter',
  dragleave: 'onDragLeave',
  dragover: 'onDragOver',
  drop: 'onDrop',
  dragend: 'onDragEnd',
  keydown: 'onKeyDown',
  keypress: 'onKeyPress',
  keyup: 'onKeyUp',
  unload: 'onUnload',
  abort: 'onAbort',
  error: 'onError',
  resize: 'onResize',
  scroll: 'onScroll',
  change: 'onChange',
  submit: 'onSubmit',
  reset: 'onReset',
  focus: 'onFocus',
  blur: 'onBlur'
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/maps/jsEvents.js
// module id = 1813
// module chunks = 25